import { createAction, props } from '@ngrx/store';
import { TableStorageActionModel } from '@models/common/table-storage-action.model';
import { CertificateModel } from '@models/configuration/certificate.model';

export const createCertificate = createAction(
    '[Certificate] Create Certificate',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const createCertificateSuccess = createAction(
    '[Certificate] Create Certificate Success',
    props<{ Certificate: CertificateModel }>()
);

export const searchCertificateStatus = createAction(
    '[CertificateStatus] Search CertificateStatus',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const searchCertificateStatusSuccess = createAction(
    '[CertificateStatus] Search CertificateStatus Success',
    props<{ CertificateStatus: CertificateModel[] }>()
);

export const searchCertificates = createAction(
    '[Certificates] Search Certificates',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const searchCertificatesSuccess = createAction(
    '[Certificates] Search Certificates Success',
    props<{ Certificates: CertificateModel[] }>()
);

export const searchCertificatesState = createAction(
    '[Certificates] Search CertificatesState',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const searchCertificatesStateSuccess = createAction(
    '[Certificates] Search CertificatesState Success',
    props<{ CertificatesByState: CertificateModel[] }>()
);

export const searchCertificatesFile = createAction(
    '[CertificatesFile] Search CertificatesFile',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const searchCertificatesFileSuccess = createAction(
    '[CertificatesFile] Search CertificatesFile Success',
    props<{ CertificatesFile: CertificateModel[] }>()
);

export const updateCertificate = createAction(
    '[Certificate] Update Certificate',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const updateCertificateSuccess = createAction(
    '[Certificate] Update Certificate Success',
    props<{ Certificate: CertificateModel }>()
);

export const selectCertificate = createAction(
    '[Certificate] Select Certificate',
    props<{ Certificate: CertificateModel }>()
);

export const deleteCertificate = createAction(
    '[Certificate] Delete Certificate',
    props<{ action: TableStorageActionModel<CertificateModel> }>()
);

export const deleteCertificateSuccess = createAction(
    '[Certificate] Delete Certificate Success',
    props<{ Certificate: CertificateModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);